import * as BizCharts from 'bizcharts';
import React, { FC } from 'react';
import './chartTheme';
import { withNiceScale } from './chartUtils';

const { Chart, Coordinate, Axis, Geom, Tooltip } = BizCharts;

interface BarChartProps {
	cols: any;
	height: number;
	data: any;
	fillArea: boolean;
	position: string;
	chartPadding?: [number, number, number, number];
	xAxisLabel?: any;
	yAxisLabel?: any;
	color?: string;
	xAxisName: string;
	yAxisName: string;
	tooltipItemTemplate?: any;
	showTooltipTitle?: boolean;
}

export const BarChart: FC<BarChartProps> = ({
	chartPadding,
	showTooltipTitle = true,
	tooltipItemTemplate,
	data,
	cols,
	color,
	height,
	fillArea,
	xAxisName,
	yAxisName,
	xAxisLabel,
	yAxisLabel,
	position,
}) => {
	return (
		<Chart
			height={height}
			padding="auto"
			data={data}
			scale={withNiceScale(cols)}
			autoFit={true}
			theme="openwrench"
		>
			<Coordinate transpose={true} />
			<Axis name={xAxisName} label={xAxisLabel} />
			<Axis name={yAxisName} label={yAxisLabel} />
			<Tooltip
				crosshairs={{ type: 'y' }}
				showTitle={showTooltipTitle}
				itemTpl={
					tooltipItemTemplate
						? tooltipItemTemplate
						: `
                    <li data-index={index}>
                        <!-- The marker for each record -->
                        <span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>
                        {name}: {value}
                    </li>
                `
				}
			/>
			<Geom type="interval" position={position} color={color} />
		</Chart>
	);
};
